angular.module('unica_wiki.wiki_controllers')

.controller('WikiListController', function(
	$rootScope, $scope, $state,
	$confirm,
	WikiListService, WikiDeleteService
) {
	$scope.wikiList = [];
	$scope.limit  = 10;
	$scope.offset = 0;
	$scope.canLoad = true;

	$scope.loadWikis = function() {
		$scope.showLoader();
		$scope.canLoad = false;
		WikiListService
			.list($scope.limit, $scope.offset)
			.then(function(data) {
				$scope.hideLoader();

				if (!data.error) {
					$scope.wikiList = $scope.wikiList.concat( data );
					if ( data.length == 0 ) {
						$scope.canLoad = false;
					} else {
						$scope.canLoad = true;
						$scope.offset = $scope.offset + data.length;
					}
				} else {
					$rootScope.manageError(data);
				}
			});
	};

	$scope.loadWikis();

	$scope.deleteWiki = function(wikiId) {
		$confirm({
			title: 'Sei sicuro di voler eliminare il dato?',
			text: 'Confermi la cancellazione del dato?'
		}).then(function() {

			$scope.showLoader();
			WikiDeleteService
				.delete( wikiId )
				.then(function(data) {
					$scope.hideLoader();

					if (!data.error) {
						angular.forEach($scope.wikiList, function(wiki, key) {
							if ( wiki.id == wikiId ) {
								$scope.wikiList.splice(key, 1);
							}
						});
						$scope.showSuccessMsg('Dato eliminato con successo!', '');
					} else {
						$rootScope.manageError(data);
					}

				});

		}, function() {
			// Cancel
		});
	};

})

;